import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandJobcardAddPage } from '../cabsand-jobcard-add/cabsand-jobcard-add';
import { SearchPage } from '../search/search';

@IonicPage()
@Component({
  selector: 'page-cabsand-jobcard',
  templateUrl: 'cabsand-jobcard.html',
})
export class CabsandJobcardPage {
  fleetList:any = [];
  jobCardList:any = [];
  completedList:any = [];
  allFleetList:any = [];

  actionAllowed:boolean = false;

  searchBy:any = "get_active_jobcard_list";
  selectedFilter = "Active"
  currentPage = 1;
  totalPage = 0;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider,public modalController :ModalController) {
  }

  

  ionViewDidLoad() {
    console.log('ionViewDidLoad KlmrJobcardPage');
    this.getPermission();
    this.getData();
  }

  async getData(){
    this.utiltiy.startLoading();

    this.fleetList = await this.getFleetList();
    this.completedList = await this.getCompletedList("completed_list");
    this.utiltiy.stopLoading();
    this.searchByFilter();

  }


  async getCompletedList(methodName) {
    let formData: FormData = new FormData();
    formData.append("method_name", methodName);
    return this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result-1", result);
        if (result.status) {
          return result.result;
        }
        return true;
      }, err => {
        console.log("err", err);
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async getFleetList() {
    this.fleetList = [];
    // this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "fleet_no_list");
    return this.api.post("/tansix_prestart/jobcard", false,formData)
      .then((result: any) => {
        console.log("result", result)
        // this.utiltiy.stopLoading();
        if (result.status) {
          var fleetList = [];
          this.allFleetList = [{"key":"All","value":"All"},{"key":"Active","value":"Active"},{"key":"Completed","value":"Completed"}]
          result.result.forEach(element => {
            this.allFleetList.push({"key":element.fleet_no,"value":element.fleet_no})
            fleetList.push({
              type: 'radio',
              label: element.fleet_no,
              value: element.fleet_no,
              key : element.fleet_no,
              id : element.id,
            })
          });
          
          return fleetList;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  previousPage(){
    this.currentPage--;
    this.searchByFilter();
  }
  nextPage(){
    this.currentPage++;
    this.searchByFilter();

  }

  async searchByFilter(){
    switch (this.selectedFilter) {
      case "All":
        this.getJobcardList("jobcard_list");
        break;
      case "Active":
        this.getJobcardList("get_active_jobcard_list");
        break;  
      case "Completed":
        this.getJobcardList("get_completed_jobcard_list");
        break;  
      default:
        this.getJobcardListWithFleet(this.selectedFilter);
        break;
    }

  }


  async getJobcardList(method) {
    this.jobCardList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    // if(method == "jobcard_list"){
      formData.append("page", this.currentPage.toString());
    // }
     this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.jobCardList = result.result
          if(result.pagination){
            this.totalPage = result.pagination.total_pages;
          }
        }
       

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();

        this.utiltiy.toaster(err.error.message);
      })
  }
  async getJobcardListWithFleet(jobNo) {
    this.jobCardList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "search_jobcard_fleet");
    formData.append("search_jobno", jobNo);
     this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.jobCardList = result.result
        }
       

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();

        this.utiltiy.toaster(err.error.message);
      })
  }

 

  async fleetListPopup(){
    this.openModal(this.fleetList);
  }

  async getUserName(id){
    let i = this.completedList.findIndex(list_ => list_.id == id);
    if(i != -1){
      return this.completedList[i].Person;
    }else{
      return "";
    }
  }

  async getFleetData(plant_item){
    // console.log("this.fleetList",this.fleetList)
    let i = this.fleetList.findIndex(list_ => list_.id == plant_item);
    if(i != -1){
      console.log(plant_item,"this.fleetList[i]",this.fleetList[i])
      return this.fleetList[i].value;
    }else{
      return "";
    }
  }

  cheeckFleetNo(fleetNo){
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
      formData.append("method_name", "check_fleet");
      formData.append("plant_item", fleetNo);
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.addJobcard(fleetNo);
        }else{
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deleteJobcard(id);
    }
    console.log("status", status);
  }

  deleteJobcard(id) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
      formData.append("method_name", "jobcard_delete");
      formData.append("id", id);
    this.api.post(`/tansix_prestart/jobcard`, false, formData)
      .then((result: any) => {
        this.utiltiy.stopLoading();
        if (result.status) {
           this.getData();
        }else{
          this.utiltiy.toaster(result.message);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  
  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-jobcard-rw");
  }
  addJobcard(fleetNumber) {
    this.navCtrl.push(CabsandJobcardAddPage, { param: null,fleet:fleetNumber });
  }
  updateJobcard(payload) {
    this.navCtrl.push(CabsandJobcardAddPage, { param: payload,fleet:payload.plant_item });
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

 

  async openModalForSearch(list, title, key, value){
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.selectedFilter = data.value;
        this.currentPage = 1;
        this.totalPage = 0;
        this.searchByFilter();
      }
    });
    profileModal.present();

  }

   async openModal( fleetList){
    const profileModal = this.modalController.create(SearchPage, { data: {list : fleetList,header:"Fleet List"}},{ cssClass: 'managers'});
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.cheeckFleetNo(data.value);
      }
    });
    profileModal.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-jobcard/cabsand-jobcard.ts